import React from "react";
import { Container, MobileViewVisibility, DesktopViewVisibility, Card, ImageLinkWrapper, ClickHereContainer, Image, BasicInfoContainer, TitleContainer, TextContainer, Title, SmallText, MoreInfoButton, InfoIcon, BasicInfoMainContainer, IconTextContainer, TextLabelContainer, Text, Label, Price, IconContainer, Icon, ButtonContainer,InputButtonContainer, InputIconContainer, Button, RupeeText, Input, ReportLink, MoreInfoContainer, MoreInfoLabel, ViewMoreButton, ImageButtonWrapper } from "./styles/cards";


export default function Cards({children,...props}){
    return <Container {...props}>{children}</Container>
}

Cards.MobileViewVisibility = function CardsMobileViewVisibility({children,...props}){
    return <MobileViewVisibility {...props}>{children}</MobileViewVisibility>
}

Cards.DesktopViewVisibility = function CardsDesktopViewVisibility({children,...props}){
    return <DesktopViewVisibility {...props}>{children}</DesktopViewVisibility>
}

Cards.Card = function CardsCard({children,...props}){
    return <Card {...props}>{children}</Card>
}

Cards.ImageLinkWrapper = function CardsImageLinkWrapper({children,...props}){
    return <ImageLinkWrapper {...props}>{children}</ImageLinkWrapper>
}

Cards.ClickHereContainer = function CardsClickHereContainer({children,...props}){
    return <ClickHereContainer {...props}>{children}</ClickHereContainer>
}

Cards.Image = function CardsImage({children,...props}){
    return <Image {...props}>{children}</Image>
}

Cards.BasicInfoContainer = function CardsBasicInfoContainer({children, ...props}){
    return <BasicInfoContainer {...props}>{children}</BasicInfoContainer>
}

Cards.TitleContainer = function CardsTitleContainer({children, ...props}){
    return <TitleContainer {...props}>{children}</TitleContainer>
}

Cards.TextContainer = function CardsTextContainer({children, ...props}){
    return <TextContainer {...props}>{children}</TextContainer>
}

Cards.Title = function CardsTitle({children, ...props}){
    return <Title {...props}>{children}</Title>
}

Cards.SmallText = function CardsSmallText({children, ...props}){
    return <SmallText {...props}>{children}</SmallText>
}

Cards.MoreInfoButton = function CardsMoreInfoButton({children, ...props}){
    return <MoreInfoButton {...props}>{children}</MoreInfoButton>
}

Cards.InfoIcon = function CardsInfoIcon({...props}){
    return <InfoIcon {...props} />
}

Cards.BasicInfoMainContainer = function CardsBasicInfoMainContainer({children, ...props}){
    return <BasicInfoMainContainer {...props}>{children}</BasicInfoMainContainer>
}

Cards.IconTextContainer = function CardsIconTextContainer({children, ...props}){
    return <IconTextContainer {...props}>{children}</IconTextContainer>
}

Cards.TextLabelContainer = function CardsTextLabelContainer({children, ...props}){
    return <TextLabelContainer {...props}>{children}</TextLabelContainer>
}

Cards.Text = function CardsText({children, ...props}){
    return <Text {...props}>{children}</Text>
}

Cards.Label = function CardsTextLabel({children, ...props}){
    return <Label {...props}>{children}</Label>
}

Cards.Price = function CardsPrice({children, ...props}){
    return <Price {...props}>{children}</Price>
}

Cards.IconContainer = function CardsIconContainer({children, ...props}){
    return <IconContainer {...props}>{children}</IconContainer>
}

Cards.Icon = function CardsIconContainer({...props}){
    return <Icon {...props} />
}

Cards.ButtonContainer = function CardsButtonContainer({children, ...props}){
    return <ButtonContainer {...props}>{children}</ButtonContainer>
}

Cards.InputButtonContainer = function CardsInputButtonContainer({children, ...props}){
    return <InputButtonContainer {...props}>{children}</InputButtonContainer>
}

Cards.InputIconContainer = function CardsInputIconContainer({children, ...props}){
    return <InputIconContainer {...props} >{children}</InputIconContainer>
}

Cards.RupeeText = function CardsRupeeText({children, ...props}){
    return <RupeeText {...props} >{children}</RupeeText>
}

Cards.Input = function CardsInput({...props}){
    return <Input {...props} ref={props.childRef} />
}

Cards.Button = function CardsButton({children, ...props}){
    return <Button {...props}>{children}</Button>
}

Cards.ReportLink = function CardsReportLink({children, ...props}){
    return <ReportLink {...props}>{children}</ReportLink>
}

Cards.MoreInfoContainer = function CardsMoreInfoContainer({children, ...props}){
    return <MoreInfoContainer {...props}>{children}</MoreInfoContainer>
}

Cards.MoreInfoLabel = function CardsMoreInfoLabel({children, ...props}){
    return <MoreInfoLabel {...props}>{children}</MoreInfoLabel>
}

Cards.ViewMoreButton = function CardsViewMoreButton({children, ...props}){
    return <ViewMoreButton {...props}>{children}</ViewMoreButton>
}

Cards.ImageButtonWrapper = function CardsImageButtonWrapper({children, ...props}){
    return <ImageButtonWrapper {...props}>{children}</ImageButtonWrapper>
}

